var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72406 1.81445C1.72406 0.986026 2.39563 0.314453 3.22406 0.314453H16.7762C17.6047 0.314453 18.2762 0.986026 18.2762 1.81445V2.38348H1.72406V1.81445Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3.88428C19.1046 3.88428 20 4.77971 20 5.88428V17.4019C19.9998 18.5062 19.1044 19.4019 18 19.4019H2C0.895561 19.4019 0.000211338 18.5062 0 17.4019V5.88428C0 4.77987 0.894678 3.88454 1.99902 3.88428H18ZM7.06836 6.29736C6.59227 6.29736 6.20611 6.68359 6.20605 7.15967C6.20605 7.63579 6.59224 8.02197 7.06836 8.02197H13.2754C13.7514 8.02181 14.1367 7.63569 14.1367 7.15967C14.1367 6.68369 13.7513 6.29753 13.2754 6.29736H7.06836Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.48b3a4c0ffcab87fbb91324c5456e839.svg";
export { ForwardRef as ReactComponent };